import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';
import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';
import HeaderBackground from '@/components/ui/header-background/header-background';
import { ROUTE_BUILD_ACTION_PLAN } from '@/constants/routes';
import useIsMobile from '@/hooks/use-is-mobile';
import { Flex, Link, Text } from '@cmpsr/components';
import { Link as ReactRouterLink } from 'react-router-dom';
import AddNewActionLink from './common/add-new-action-link';

type ActionPlanHeaderProps = {
  hasPlan: boolean;
  potentialRiskDecrease?: number;
  allInterventionsCompleted: boolean;
};

export default function ActionPlanHeader({
  hasPlan,
  potentialRiskDecrease,
  allInterventionsCompleted,
}: ActionPlanHeaderProps) {
  const isMobile = useIsMobile();
  const size = isMobile ? 's' : 'l';

  return (
    <DashboardLayout
      containerProps={{
        position: 'relative',
        overflow: 'hidden',
      }}
      contentProps={{ as: 'header' }}
    >
      <HeaderBackground blur={30} />
      <DashboardGrid gap={{ base: 5, lg: 8, xl: 9, xxl: 12 }} position="relative" zIndex={1}>
        <Flex direction="column" alignItems="flex-start" w="full">
          <Text as="h1" variant="text-header-4XL" mb={2} color="tan">
            Your Action{' '}
            <Text as="span" textStyle="text-header-4xl-v" color="tan">
              Plan
            </Text>
          </Text>
          {hasPlan ? (
            <Text variant="text-body-regular" fontSize={{ base: '14px', lg: '16px' }} color="tan">
              Your Action Plan is comprised of up to five Actions to reduce your cancer risk. You can add or remove
              actions any time.
            </Text>
          ) : null}
        </Flex>

        <Flex alignItems={{ base: 'flex-start', lg: 'center' }} justifyContent={{ base: 'flex-start', lg: 'flex-end' }}>
          {hasPlan ? (
            allInterventionsCompleted ? (
              <AddNewActionLink variant="responsiveMd" />
            ) : (
              <Link
                as={ReactRouterLink}
                to={ROUTE_BUILD_ACTION_PLAN}
                variant="primary-alt"
                size={size}
                justifyContent="center"
                flexShrink={0}
                w="auto"
                py={{ base: 2, lg: 4 }}
                px={{ base: 5, lg: 7 }}
              >
                <Text variant="text-body-medium">Edit Plan</Text>
              </Link>
            )
          ) : (
            <Link
              as={ReactRouterLink}
              to={ROUTE_BUILD_ACTION_PLAN}
              variant="accent"
              size={size}
              justifyContent="center"
              flexShrink={0}
              w="auto"
              py={{ base: 2, lg: 4 }}
              px={{ base: 5, lg: 7 }}
            >
              <Text variant="text-body-medium">Create Plan</Text>
            </Link>
          )}
        </Flex>
      </DashboardGrid>
    </DashboardLayout>
  );
}
